import { deriveComplaintBackendUrl } from "./utils/closeReasonUtils";

export const baseUrl = process.env.REACT_APP_CONNECT_PATH;
export const oldUrl = process.env.REACT_APP_OLD_CONNECT_PATH;
export const webBaseUrl = process.env.REACT_APP_WEBSITE_PATH;
// Host of the new consolidated backends (e.g. https://stage-app.gonoise.com). Service
// paths (/connect-complaint/..., /connect-master/...) are composed in the action calls.
export const newBackendBaseUrl = process.env.REACT_APP_CONNECT_BACKEND_NEW_BASE_URL;
